<template>
    <v-list-item
        link
        :to="item.route"
        active-class="menu-item-active"
        class="menu-item rounded-lg"
        :class="nested ? 'menu-item--nested' : 'mb-1'"
        @click.native="emitEvent(item)"
    >
        <v-list-item-icon v-if="!nested" class="mr-3 my-auto">
            <v-icon size="18">{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
            <v-list-item-title class="menu-item-text">{{ item.name }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
import { eventHub } from "@/main";

export default {
    name: "MenuItem",

    props: {
        item: { type: Object, required: true },
        // Item de submenu: sem icone, mais baixo (o grupo ja mostra o icone).
        nested: { type: Boolean, default: false },
    },

    methods: {
        emitEvent(item) {
            if (item.event) {
                eventHub.$emit(item.event);
                return;
            }

            eventHub.$emit('close-menu');
        },
    },
};
</script>

<style lang="scss" scoped>
.menu-item {
    min-height: 36px;
    height: 36px;
    padding: 0 10px;
    border-radius: 8px !important;

    &::before {
        border-radius: 8px;
    }

    .v-list-item__icon {
        margin-right: 12px !important;
    }

    .v-icon {
        color: rgba(255, 255, 255, 0.55) !important;
    }
}

.menu-item-text {
    font-size: 13.5px !important;
    font-weight: 500 !important;
    color: rgba(255, 255, 255, 0.78) !important;
}

// Item de submenu: mais baixo, sem icone.
.menu-item--nested {
    min-height: 32px;
    height: 32px;
    margin-bottom: 1px;
    padding: 0 10px;

    .menu-item-text {
        font-size: 13px !important;
        font-weight: 400 !important;
        color: rgba(255, 255, 255, 0.62) !important;
    }
}

.menu-item:hover {
    background-color: rgba(255, 255, 255, 0.06) !important;

    .menu-item-text,
    .v-icon {
        color: #ffffff !important;
    }
}

.menu-item-active {
    background-color: rgba(255, 255, 255, 0.1) !important;

    &::before {
        opacity: 0 !important;
    }

    .v-icon {
        color: #ffffff !important;
    }

    .menu-item-text {
        color: #ffffff !important;
        font-weight: 500 !important;
    }
}
</style>
